import React from 'react';
import SearchBar from '../SearchBar';
import SearchIcon from '../../assets/icons/search.svg';
import './styles.scss';
import { api } from '../../utils';
import { botID, Roles } from '../../constants';
import DefaultBotIcon from '../../assets/icons/Black_and_white_boticon.svg';
import CollapsbleIcon from '../../assets/icons/collapsble_icon.svg';
import ExpandableIcon from '../../assets/icons/expandable_icon.svg';
// import Button from '../../CommonComponents/Button';
import Modal from '../../CommonComponents/Modal';
import AddBot from '../../ConfigurationPannel/AddBot';
import AddImage from '../../assets/icons/add.svg';

type Props = {
	fetchbotData?: Function;
	botHeader: string;
	botFilterHeader: string;
	showCollapsepannel?: boolean;
	Collapsepannel?: Function;
	selectedBotId: string;
	selectedBotName: string;
	selectedBotIconUrl: string;
	selectedBaseURL: string;
	source: string;
	redirectionToLoginPage: Function;
	tenantId: number;
	role?: string;
	toasterNotify?: any;
};

type State = {
	searchTerm: string;
	botFilter: {
		botName: string;
		botid: string;
		botIconUrl: string;
		baseURL: string;
	}[];
	selectedBotid: string;
	selectedBoticonurl: string;
	selectedBotname: string;
	selectedBaseurl: string;
	showCollapsepannel: boolean;
	shwBotPannel: boolean;
	showCollapsepanneldata: boolean;
	addNewBot: boolean;
};

export default class BotPannel extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = this.setInitialState();
		this.closeModal = this.closeModal.bind(this);
		this.addNewBotApi = this.addNewBotApi.bind(this);
		this.checkBotIDValidation = this.checkBotIDValidation.bind(this);
	}
	setInitialState(): State {
		return {
			searchTerm: '',
			botFilter: [],
			selectedBotid: botID,
			selectedBoticonurl:
				'https://s3-us-west-2.amazonaws.com/sfproducshowCollapsepanneltnew/dont_delete_me/senzo.svg2020-07-17_08:23:01.153',
			selectedBotname: 'Testing Bot1',
			selectedBaseurl: 'https://aware.senseforth.com',
			showCollapsepannel: false,
			shwBotPannel: true,
			showCollapsepanneldata: false,
			addNewBot: false,
		};
	}
	componentDidMount() {
		this.fetchBotFilter();
		if (
			this.props.selectedBotIconUrl !== '' ||
			this.props.selectedBotIconUrl !== undefined
		) {
			this.setState({
				selectedBoticonurl: this.props.selectedBotIconUrl,
			});
		}
		if (
			this.props.selectedBotId !== '' ||
			this.props.selectedBotId !== undefined
		) {
			this.setState({
				selectedBotid: this.props.selectedBotId,
			});
		}
		if (
			this.props.selectedBotName !== '' ||
			this.props.selectedBotName !== undefined
		) {
			this.setState({
				selectedBotname: this.props.selectedBotName,
			});
		}
		if (
			this.props.selectedBaseURL !== '' ||
			this.props.selectedBaseURL !== undefined
		) {
			this.setState({
				selectedBaseurl: this.props.selectedBaseURL,
			});
		}
	}
	get botfilterSearch() {
		const searchTerm = this.state.searchTerm.toLowerCase();

		return this.state.botFilter.filter(
			(botFilter) => botFilter.botName.toLowerCase().indexOf(searchTerm) >= 0
		);
	}
	botconfig(selectedBotdata: any) {
		this.setState({
			selectedBotid: selectedBotdata.botid,
			selectedBoticonurl: selectedBotdata.botIconUrl,
			selectedBotname: selectedBotdata.botName,
			selectedBaseurl: selectedBotdata.baseURL,
		});
		this.props.fetchbotData && this.props.fetchbotData(selectedBotdata);
	}
	fetchBotFilter() {
		let agentId = sessionStorage.getItem('agentId');

		// `listOfBots?loggedInAgentId=${agentId}&screenName=${this.props.source}&tenantId=${
		//   this.props.tenantId
		// }&agentSessionID=${sessionStorage.getItem('agentActiveSession')}`

		api(`listOfBots`, 'POST', {
			loggedInAgentId: agentId,
			tenantId: this.props.tenantId,
			screenName: this.props.source,
			agentSessionID: sessionStorage.getItem('agentActiveSession'),
		}).then((response) => {
			if (response.error === 'Authentication Failed') {
				this.props.redirectionToLoginPage();
			} else {
				// if (response.redirectToLogin === true) {
				// 	this.props.redirectionToLoginPage();
				// } else {
				this.setState({
					botFilter: response.JsonResp.map((botdata: any) => ({
						botName: botdata.botName,
						botid: botdata.botId,
						botIconUrl: botdata.botIconURL,
						baseURL: botdata.envURL,
					})),
					selectedBoticonurl: response.JsonResp[0].botIconURL,
					selectedBotid: response.JsonResp[0].botId,
					selectedBotname: response.JsonResp[0].botName,
					selectedBaseurl: response.JsonResp[0].envURL,
				});
				this.props.fetchbotData &&
					this.props.fetchbotData(response.JsonResp[0]);
			}
		});
	}
	hideCollapsepannel() {
		this.setState({
			shwBotPannel: !this.state.shwBotPannel,
		});
	}
	closeModal() {
		this.setState({
			addNewBot: false,
		});
	}
	checkBotIDValidation(id: string) {
		if (id.length !== 24) {
			return false;
		} else {
			return true;
		}
	}
	addNewBotApi(
		botID: string,
		botName: string,
		awareENV: string,
		awareEnvURL: string,
		botIconURL: string
	) {
		let botIdValidation = this.checkBotIDValidation(botID);
		if (botIdValidation) {
			api('addBot', 'POST', {
				botID: botID,
				botName: botName,
				awareENV: awareENV,
				awareEnvURL: awareEnvURL,
				botIconURL: botIconURL,
				tenantId: this.props.tenantId,
				agentId: sessionStorage.getItem('agentId'),
			}).finally(() => {
				this.setState(
					{
						addNewBot: false,
					},
					() => {
						this.fetchBotFilter();
						this.props.toasterNotify('New Bot added successfully');
					}
				);
			});
		} else if (botIdValidation === false) {
			let IdValidation = document.getElementById('botId-validation-error');
			if (IdValidation) {
				IdValidation.innerHTML = 'Please enter a valid bot ID';
			}

			return false;
		}
	}
	render() {
		return (
			<>
				{this.state.shwBotPannel ? (
					<div className='bot-config'>
						<div
							className={`analyze ${
								this.props.botHeader === 'Configure' ? 'bot-header' : ''
							}`}>
							{this.props.botHeader}
						</div>
						{/* <Button
                  theme='dark'
                  text='+ Add Bot'
                  // disabled={this.isConfirmDisabled || !this.props.isEditable}
                  onClick={() => {
                    this.setState({
                      addNewBot: true,
                    });
                  }}
                /> */}
						{this.props.botHeader === 'Configure' &&
						this.props.role === Roles.TENANTADMIN.value ? (
							<div
								className='add-new-bot'
								onClick={() => {
									this.setState({
										addNewBot: true,
									});
								}}>
								{/* <img src={AddImage} alt='add queue' /> */}
								Add Bot
							</div>
						) : null}
						<div className='bot-list-header'>
							Select a bot to {this.props.botHeader !== 'Configure' && 'view'}{' '}
							{this.props.botFilterHeader}
						</div>
						<div className='search-bar'>
							<SearchBar
								placeholder='Search bots'
								icon={SearchIcon}
								importedImg='yes'
								onSearch={(term: any) => {
									this.setState({
										searchTerm: term,
									});
								}}
							/>
						</div>
						<div className='bot-data-header'>
							{this.botfilterSearch.map((botfilterData, index) => {
								return (
									<div
										key={index}
										onClick={this.botconfig.bind(this, botfilterData)}
										className={`bot-data-content ${
											this.state.selectedBotname === botfilterData.botName
												? 'bot-selected'
												: ''
										}`}>
										<img
											src={
												botfilterData.botIconUrl
													? botfilterData.botIconUrl
													: DefaultBotIcon
											}
											alt='boticon'
											className='bot-icon'
										/>
										<div className='bot-name'>{botfilterData.botName}</div>
									</div>
								);
							})}
							<div
								className='collapse-bot-data collapse-btn-data'
								onClick={() => {
									this.hideCollapsepannel && this.hideCollapsepannel();
									this.props.Collapsepannel && this.props.Collapsepannel();
								}}>
								<img src={CollapsbleIcon} alt='collapsble-icon' />
							</div>
						</div>
					</div>
				) : (
					<div className='bot-config'>
						<div
							className='bot-data-header'
							style={{ marginTop: '37px', height: 'calc(100vh - 180px)' }}>
							{this.botfilterSearch.map((botfilterData, index) => {
								return (
									<div
										key={index}
										onClick={this.botconfig.bind(this, botfilterData)}
										className={`bot-data-content ${
											this.state.selectedBotname === botfilterData.botName
												? 'bot-selected'
												: ''
										}`}
										style={{
											borderBottom: 'none',
											padding: '7px 15px',
										}}>
										<img
											src={
												botfilterData.botIconUrl
													? botfilterData.botIconUrl
													: DefaultBotIcon
											}
											alt='boticon'
											className='bot-icon'
											style={{ marginLeft: '0px' }}
										/>
										{/* <div className='bot-name'>{botfilterData.botName}</div> */}
									</div>
								);
							})}
							{/* {this.state.showCollapsepanneldata && ( */}
							<div
								className='collapse-bot-data collapse-btn-data1'
								onClick={() => {
									this.hideCollapsepannel && this.hideCollapsepannel();
									this.props.Collapsepannel && this.props.Collapsepannel();
								}}>
								<img src={ExpandableIcon} alt='collapsble-icon' />
							</div>
							{/* )} */}
						</div>
					</div>
				)}
				{this.state.addNewBot ? (
					<Modal
						title='Add New Bot'
						isOpen={true}
						onClose={this.closeModal}
						style={{
							height: '100vh',
							padding: '8px 0px 30px 30px',
						}}
						//   disableCloseButton={props.tenantAdminProcessing}
					>
						<AddBot
							closeModal={this.closeModal}
							addNewBotApi={this.addNewBotApi}
						/>
					</Modal>
				) : null}
			</>
		);
	}
}
